/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  ProductListingLoader.tsx
*
* Project Title :  Checkout
*
* Description	: Purchase Software page
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H175591
*
* @Date		    : Oct 1, 2019
*
* @Version      : Version 1.0
*
******************************************************************************/
import React from 'react';
import GenericLoader from '../../Loader/Loader';

function ProductListingLoader() {
    return (
        <GenericLoader text="Fetching Products" className="products-loader" loading={true} overlayColor="rgb(247, 247, 247)" />
    );
}

export default ProductListingLoader;